// ContactUs.jsx
import React, { useState, useContext } from 'react';
import '../assets/css/ContactUs.css';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import HighlightsCarousel from '../components/HighlightsCarousel';
import { LanguageContext } from '../contexts/LanguageContext';
import { t } from 'i18next';

const HeroSection = ({ title, subtitle }) => (
  <header className="hero">
    <div className="hero-overlay">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  </header>
);

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const response = await fetch('https://3sss.cm/sendMail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData)
      });

      const text = await response.text();
      if (text === 'success') {
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus('Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setStatus('An error occurred. Please try later.');
    }
  };

  const { t } = useContext(LanguageContext);
  return (
    <section className="contact-container">
      {/* Contact details */}
      <div className="contact-info">
        <h2 className="contact-title">{t.contact_page_get_in_touch}</h2>
        <p className="contact-subtitle">{t.contact_page_description}</p>

        <ul className="contact-details">
          <li><FaPhoneAlt className="icon" /> <span>+237 681 123 480 / +237 681 123 155 / +237 681 123 150</span></li>
          <li><FaEnvelope className="icon" /> <span>contact@3sss.cm</span></li>
          <li><FaMapMarkerAlt className="icon" /> <span>Douala, Cameroon</span></li>
        </ul>
      </div>

      {/* Inquiry form */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <h3 className="form-title">{t.send_us_a_message}</h3>

        <div className="form-group">
          <label htmlFor="name">{t.name}</label>
          <input
            id="name"
            type="text"
            placeholder={t.name_placeholder}
            required
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">{t.email}</label>
          <input
            id="email"
            type="email"
            placeholder={t.email_placeholder}
            required
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="subject">{t.subject}</label>
          <input
            id="subject"
            type="text"
            placeholder={t.subject_placeholder}
            required
            value={formData.subject}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">{t.message}</label>
          <textarea
            id="message"
            rows="6"
            placeholder={t.message_placeholder}
            required
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>

        <button type="submit" className="submit-btn">{t.send_message_btn}</button>
        {status && <p className="form-status">{status}</p>}
      </form>
    </section>
  );
};

export default function () {
  const { t } = useContext(LanguageContext);
  return (
    <>
      <HeroSection
        title={t.contact_page_title}
        subtitle=""
      />
      <ContactUs />
      <div className="news-section">
        <p>{t.our_blog}</p>
        <h2>
          <span className="highlight">{t.news_section_highlight} </span>{t.news_section_opening}
        </h2>
        <p className="opening">{t.news_section_description}</p>
        <HighlightsCarousel />
      </div>
    </>
  );
}
